import { Box, Tooltip } from '@mui/material';
import { formatInOffset, formatLocal, localZoneLabel, offsetLabel } from '../utils/timezone';

/** The report timezone selects the window, not the wall clock. Hover keeps it reachable. */
export default function TimeCell({ value, tz }: { value: unknown; tz: number }) {
  if (value === null || value === undefined || value === '') return <>-</>;
  return (
    <Tooltip
      arrow
      placement="top"
      title={(
        <Box sx={{ whiteSpace: 'nowrap', lineHeight: 1.6, py: 0.25 }}>
          <div>{localZoneLabel()}: {formatLocal(value as string)}</div>
          <div>Report {offsetLabel(tz)}: {formatInOffset(value as string, tz)}</div>
        </Box>
      )}
    >
      <span>{formatLocal(value as string)}</span>
    </Tooltip>
  );
}
